module.exports = __webpack_public_path__ + "img/img2.006b428a.png";